/**
 * Labstep
 *
 * @module components/AccessKey/Manager
 * @desc AccessKey manager
 */

import { AccessKeyActionCreate } from 'labstep-web/components/AccessKey/Action/Create';
import { AccessKeyTableContainer as AccessKeyTable } from 'labstep-web/components/AccessKey/Table';
import { Container } from 'labstep-web/components/Layout/Container';
import type React from 'react';

export const AccessKeyManager: React.FC = () => (
  <div id="access-key-card">
    <Container>
      <AccessKeyActionCreate />
    </Container>
    <Container>
      <AccessKeyTable />
    </Container>
  </div>
);
